import { CreateHelcimCustomerDto, CreateTokenSessionReq, HelcimCustomerResponseDto, HelcimPaymentReturnRequest, RefundRequestDto, RefundResponseDto } from "../../interfaces";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { apiDelete, apiGet, apiPost } from "../../utilities/api-client/apiRequest";

export async function createHelcimCustomerAsync(
    authToken: string,
    payload: CreateHelcimCustomerDto,
    signal?: AbortSignal
): Promise<ApiResponse<HelcimCustomerResponseDto>> {
    const apiUrl: string = `/payment/helcim/createCustomer`;

    const res = apiPost<ApiResponse<HelcimCustomerResponseDto>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function createHelcimCheckoutTokenAsync(
    authToken: string,
    payload : CreateTokenSessionReq,
    signal?: AbortSignal
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/payment/helcim/create-token-session
`;

    const res = apiPost<ApiResponse<string>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function savePaymentMethodAsync(
    authToken: string,
    payload : HelcimPaymentReturnRequest,
    signal?: AbortSignal
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/payment/helcim/payment-return`;

    const res = apiPost<ApiResponse<string>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function GetInvoiceByInvoiceNumberAsync(
    authToken: string,
    invoiceNumber : string,
    signal?: AbortSignal
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/payment/helcim/GetInvoiceByInvoiceNumber?invoiceNumber=${invoiceNumber}`;

    const res = apiGet<ApiResponse<string>>(
        apiUrl, authToken, signal
    );
    return res;
}

export async function CreateRefundAsync(
    authToken: string,
    payload : RefundRequestDto,
    signal?: AbortSignal
): Promise<ApiResponse<RefundResponseDto>> {
    const apiUrl: string = `/payment/helcim/Refund`;

    const res = apiPost<ApiResponse<RefundResponseDto>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function RemovePaymentMethodAsync(
    authToken: string,
    paymentMethodId: string,
    signal?: AbortSignal
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/payment/helcim/payment-method/${paymentMethodId}`;

    const res = apiDelete<ApiResponse<string>>(
        apiUrl, null, authToken, signal
    );
    return res;
}